export default __webpack_public_path__ + "static/1282-57c82b6174bcd0c1c642ad3d58f11220.gif";